import { z } from 'zod';

export const createApiResponseSchema = <T extends z.ZodTypeAny>(data: T) =>
  z.object({
    data,
  });

export const createApiPagedResponseSchema = <T extends z.ZodTypeAny>(item: T) =>
  z.object({
    data: z.array(item),
    total: z.number().int().nonnegative(),
    pageSize: z.number().int().positive(),
    current: z.number().int().positive(),
  });

export type ApiPagedResponse<T> = {
  data: T[];
  total: number;
  pageSize: number;
  current: number;
};
